import { Box } from '@factorialco/deprecated-design-system'
import {
  ContractHistoryActivityPeriodFragment,
  ContractHistoryContractVersionHistoryFragment,
  ContractHistoryContractVersionUpdateFragment,
  JobCatalogTreeLevelNodeFragment
} from 'generated/resources/graphql'

import ContractVersionCard from 'modules/contracts/components/NewContractHistory/ContractVersionCard'
import PeriodCard from 'modules/contracts/components/NewContractHistory/ContractVersionCard/FDPeriods/PeriodCard'
import Timeline from 'modules/contracts/components/NewContractHistory/TimeLine'
import { Contract } from 'modules/contracts/components/NewContractHistory/types'
import { getVersionData } from 'modules/contracts/lib/ContractHistoryUtils'
import ContractVersionContract from 'modules/contracts/lib/contractVersionContract'

interface Props {
  activityPeriod: ContractHistoryActivityPeriodFragment
  contractVersionUpdates: ContractHistoryContractVersionUpdateFragment[]
  versions: ContractHistoryContractVersionHistoryFragment[]
  contract: Contract
  firstContract: boolean
  onContractVersionSelect?: (referenceVersionId: number | undefined) => void
  selectedContractVersionId: number | undefined
  contractOngoingActivityPeriod?: ContractHistoryActivityPeriodFragment | undefined
  jobCatalogTreeLevelNodes?: JobCatalogTreeLevelNodeFragment[]
}

const ActivityPeriod = ({
  activityPeriod,
  contractVersionUpdates,
  versions,
  contract,
  firstContract,
  onContractVersionSelect,
  selectedContractVersionId,
  contractOngoingActivityPeriod,
  jobCatalogTreeLevelNodes
}: Props) => {
  const referenceVersion = getVersionData(activityPeriod.referenceVersionId, versions)

  if (!referenceVersion) return null

  const contractContract = ContractVersionContract.fromContract(contract)
  const hasMultipleActivityPeriods = contractContract.hasMultipleActivityPeriods()
  const showRail = hasMultipleActivityPeriods && !contractContract.isFirstVersion(referenceVersion)
  const isSingleUpcomingActivityPeriod =
    activityPeriod.schedule === 'upcoming' &&
    activityPeriod.periods?.length === 1 &&
    contract.isDiscontinuous
  const filteredActivityPeriods = !isSingleUpcomingActivityPeriod ? activityPeriod.periods : []

  return (
    <Box key={referenceVersion.id} flexDirection="column" width="full">
      {contract.isDiscontinuous &&
        filteredActivityPeriods?.map((period, index) => (
          <Timeline.Milestone key={index} status={period.schedule} type={period.type}>
            <Timeline.Line />
            <Box style={{ marginBottom: '16px' }} width="full">
              <PeriodCard
                period={period}
                status={period.schedule}
                version={getVersionData(Number(period.contractVersionId), versions)}
                selectedContractVersionId={selectedContractVersionId}
                onContractVersionSelect={onContractVersionSelect}
                contractOngoingActivityPeriodId={contractOngoingActivityPeriod?.referenceVersionId}
              />
            </Box>
          </Timeline.Milestone>
        ))}
      <Timeline.Milestone status={activityPeriod.schedule}>
        {showRail && <Timeline.Line />}
        <Box style={{ marginBottom: '16px' }} width="full">
          <ContractVersionCard
            key={referenceVersion.id}
            version={referenceVersion}
            firstContractVersion={contractContract.isFirstVersion(referenceVersion)}
            firstContract={firstContract}
            onContractVersionSelect={onContractVersionSelect}
            selectedContractVersionId={selectedContractVersionId}
            activityPeriod={activityPeriod}
            contractVersionUpdates={contractVersionUpdates}
            contractOngoingActivityPeriod={contractOngoingActivityPeriod}
            isSingleUpcomingActivityPeriod={isSingleUpcomingActivityPeriod}
            jobCatalogTreeLevelNodes={jobCatalogTreeLevelNodes}
          />
        </Box>
      </Timeline.Milestone>
    </Box>
  )
}

export default ActivityPeriod
